var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.groups),function(group){return _c('v-flex',{key:group._id,attrs:{"xs12":"","sm6":"","md4":""}},[_c('web-group-card',{attrs:{"group":group,"collections":_vm.collections}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51aa9a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Groups.vue
// module id = jsS/
// module chunks = 1